import React, { useState, useEffect, useTransition } from "react";
import { useHistory } from "react-router-dom";
import styles from "./ManagementTeam.module.css";
import Header from "../components/Header";
import Toggler from "../components/Toggler";
import PinPopUp from "../components/PinPopUp";
import { useAccountInfoContext } from "../utils/AccountInfoContext";
import { useTranslation } from "react-i18next";

export function ManagementTeam() {
  const history = useHistory();
  const {
    canAccessMT,
    allowFaceAuth,
    setAllowFaceAuth,
    updateCanAccessMT,
    pinCreatedOn,
  } = useAccountInfoContext();

  const [isOpen, setIsOpen] = useState(false);
  const [pinFormattedDate, setPinFormattedDate] = useState("");
  const {t} = useTransition();

  useEffect(() => {
    const formatPinDate = () => {
      if (pinCreatedOn) {
        const date = new Date(pinCreatedOn);
        const formatTime = new Intl.DateTimeFormat("en-US", {
          hour: "2-digit",
          minute: "2-digit",
          timeZoneName: "short",
        });

        let formattedTime = formatTime.format(date);
        const parts = formattedTime.split(" ");
        const timeZone = parts[2];
        const timeWithParentheses = `${parts[0]} ${parts[1]} (${timeZone})`;

        return `${
          date.getMonth() + 1
        }.${date.getDate()}.${date.getFullYear()} ${timeWithParentheses}`;
      }
      return "";
    };

    setPinFormattedDate(formatPinDate());
  }, [isOpen, pinCreatedOn]);

  const handleAuthToggle = async () => {
    const newAllowFaceAuth = !allowFaceAuth;
    try {
      await updateCanAccessMT.mutateAsync({ allowFaceTouch: newAllowFaceAuth });
      setAllowFaceAuth(newAllowFaceAuth);
    } catch (error) {
      console.error(t("Error updating management team"), error);
    }
  };

  const handleHeaderBackClick = () => {
    history.push("/");
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <Header header={t("Settings")} onClick={handleHeaderBackClick} />
      </div>
      <div className="content">
        <>
          <div className={styles.titleContainer}>
            <h3 className={styles.title}>{t("Management Team PIN")}</h3>
            <button
              className={styles.changeBtn}
              onClick={() => {
                setIsOpen(true);
              }}
            >
              {t("Change")}
            </button>
          </div>
          {pinCreatedOn && (
            <div>
              <p className={styles.date}>{t("Added")} {pinFormattedDate}</p>
            </div>
          )}
          <div className={styles.hr} />
        </>
        <div className={styles.toggleContainer}>
          <p className={styles.text}>
            {t("Allow Face/Touch authentication")}
          </p>
          <Toggler
            toggled={allowFaceAuth}
            color={allowFaceAuth ? "#39B54A" : "#D3D3D3"}
            visible={true}
            readOnly={false}
            disabled={false}
            onChange={handleAuthToggle}
          />
        </div>
      </div>

      <PinPopUp
        isOpen={isOpen}
        onClose={() => {
          setIsOpen(false);
        }}
      />
    </div>
  );
}
